import React from "react";
import "../App.css";

function Profile({ user, isAuthenticated }) {
  return (
    isAuthenticated && (
      <div className="profile-pic">
        <img src={user.picture} alt={user.name} className="pic" />
      </div>
    )
  );
}

export default Profile;
